module.exports = __webpack_public_path__ + "static/media/stedelijk.099d5b1b.jpg";